import { IFetchParams, IFetchResponse } from "@/composables/useFetchWithPagination"
import { http } from "~/utils/axios.util"

export interface ISearchParams extends IFetchParams {}

interface ILink {
  url: string
  target: string
  name: string
  rel: string | null
}

interface IImage {
  alt: string
  url: string
}

export interface ISearchItem {
  id: number
  title: string
  intro: string
  link: ILink
  tags: string[] | null
  date: string | null
  url: string
  image: IImage
}

export const SearchRepository = {
  Get: (params: ISearchParams) =>
    http.get<IFetchResponse<ISearchItem>>("/search/get", {
      params,
    }),
}
